import plugin_vue3_A0OWXRrUgq from "/home/node/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/node/app/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_D7WGfuP1A0 from "/home/node/app/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_Pg0DINazwm from "/home/node/app/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_3cwHvxIDEX from "/home/node/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import openreplay_client_x9gNryAGwo from "/home/node/app/plugins/openreplay.client.ts";
import router_scrollBehavior_6se0L5aCQz from "/home/node/app/plugins/router.scrollBehavior.js";
import sentry_client_shVUlIjFLk from "/home/node/app/plugins/sentry.client.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_D7WGfuP1A0,
  router_Pg0DINazwm,
  prefetch_client_3cwHvxIDEX,
  openreplay_client_x9gNryAGwo,
  router_scrollBehavior_6se0L5aCQz,
  sentry_client_shVUlIjFLk
]